import { CommonModule } from '@angular/common';
import { Component, DestroyRef, NO_ERRORS_SCHEMA } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { WalletDataService } from 'src/app/services/data/wallet-data.service';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { CountryAcronyms, PersonType } from 'src/app/services/models/enums';
import { AppConfigService } from 'src/app/services/app-config.service';

@Component({
  selector: 'app-person-type-toggle',
  templateUrl: './person-type-toggle.component.html',
  styleUrls: ['./person-type-toggle.component.scss'],
  imports: [MatDialogModule, MatSlideToggleModule, CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PersonTypeToggleComponent {
  private readonly urlAssets: string = localStorage.getItem('urlAssets');

  wallets = this.walletDataService.getWalletsValue();
  currentPersonType = PersonType.COMPANY;
  isHuman = false;
  isLoading = false;

  constructor(
    private readonly globalService: GlobalServiceService,
    private readonly walletDataService: WalletDataService,
    private readonly appConfig: AppConfigService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.globalService
      .getPersonType$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((type) => {
        this.currentPersonType = type;
      });

    this.walletDataService
      .getWallets$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((wallets) => {
        this.wallets = wallets;
      });
  }

  get companyIconURL() {
    const selectedIcon = 'carteras-no-select-company.png';
    const unselectedIcon = 'carteras-select-company.png';

    return `${this.urlAssets}/icons/${this.isHuman ? selectedIcon : unselectedIcon}`;
  }

  get humanIconURL() {
    const selectedIcon = 'carteras-select-human.png';
    const unselectedIcon = 'carteras-no-select.png';

    return `${this.urlAssets}/icons/${this.isHuman ? selectedIcon : unselectedIcon}`;
  }

  get canShowPersonTypeToggle() {
    if (!this.appConfig.config.featureToggles?.showPersonTypeToggle) return false;

    const userCountry = localStorage.getItem('userCountry');
    const countriesWithPermission = [
      CountryAcronyms.Argentina,
      CountryAcronyms.Chile,
      CountryAcronyms.Paraguay,
      CountryAcronyms.Peru,
      CountryAcronyms.Brazil,
    ];

    return countriesWithPermission.includes(userCountry as CountryAcronyms);
  }

  get isPersonTypeToggleDisabled() {
    return this.isLoading;
  }

  handlePersonTypeToggleChange() {
    if (this.isPersonTypeToggleDisabled) return;

    this.isLoading = true;

    setTimeout(() => {
      this.isLoading = false;
    }, 3000);

    if (this.currentPersonType !== PersonType.COMPANY) {
      this.isHuman = false;
      this.globalService.setPersonType(PersonType.COMPANY);
    } else {
      this.isHuman = true;
      this.globalService.setPersonType(PersonType.PERSON);
    }
  }
}
